// import { createSelector } from 'reselect'

// (state) => [dataset]
export const datasetSelector = (state) => state.dataset



// WEBPACK FOOTER //
// ./src/selectors/shared-dataset.js